export const COUNTRIES = [
	{
		code: 'KH',
		name: 'Cambodia',
		language: 'Khmer',
		dial: '+855',
		flag: '/flags/img_flag_cambodia_32.svg',
	},
	{
		code: 'US',
		name: 'United States',
		dial: '+1',
		flag: '/flags/img_flag_us_32.svg',
	},
	{
		code: 'KR',
		name: 'South Korea',
		dial: '+82',
		flag: '/flags/img_flag_korea_32.svg',
	},
	{
		code: 'JP',
		name: 'Japan',
		dial: '+81',
		flag: '/flags/img_flag_japan_32.png',
	},
	{
		code: 'SG',
		name: 'Singapore',
		dial: '+65',
		flag: '/flags/img_flag_singapore_32.svg',
	},
	{
		code: 'VN',
		name: 'Vietnam',
		dial: '+84',
		flag: '/flags/img_flag_vietnam_32.svg',
	},
	{
		code: 'ID',
		name: 'Indonesia',
		dial: '+62',
		flag: '/flags/img_flag_indonesia_32.svg',
	},
	{
		code: 'TH',
		name: 'Thailand',
		dial: '+66',
		flag: '/flags/img_flag_thailand_32.svg',
	},
	{
		code: 'PH',
		name: 'Philippines',
		dial: '+63',
		flag: '/flags/img_flag_philippines_32.svg',
	},
	{
		code: 'LA',
		name: 'Laos',
		dial: '+856',
		flag: '/flags/img_flag_laos_32.svg',
	},
	{
		code: 'CN',
		name: 'China',
		dial: '+86',
		flag: '/flags/img_flag_china_32.svg',
	},
	{
		code: 'MY',
		name: 'Malaysia',
		dial: '+60',
		flag: '/flags/img_flag_malaysia_32.svg',
	},
	{
		code: 'IN',
		name: 'India',
		dial: '+91',
		flag: '/flags/img_flag_india_32.svg',
	},
	{
		code: 'CA',
		name: 'Canada',
		dial: '+1',
		flag: '/flags/img_flag_canada_32.svg',
	},
	{
		code: 'GB',
		name: 'United Kingdom',
		dial: '+44',
		flag: '/flags/img_flag_uk_32.svg',
	},
	{
		code: 'FR',
		name: 'France',
		dial: '+33',
		flag: '/flags/img_flag_france_32.svg',
	},
	{
		code: 'DE',
		name: 'Germany',
		dial: '+49',
		flag: '/flags/img_flag_germany_32.svg',
	},
	{
		code: 'AU',
		name: 'Australia',
		dial: '+61',
		flag: '/flags/img_flag_australia_32.svg',
	},
	{
		code: 'SE',
		name: 'Sweden',
		dial: '+46',
		flag: '/flags/img_flag_sweden_32.svg',
	},
	{
		code: 'NL',
		name: 'Netherlands',
		dial: '+31',
		flag: '/flags/img_flag_Netherlands_32.svg',
	},
	{
		code: 'CH',
		name: 'Swiss',
		dial: '+41',
		flag: '/flags/img_flag_Swiss_32.svg',
	},
	{
		code: 'RU',
		name: 'Russia',
		dial: '+7',
		flag: '/flags/img_flag_Russia_32.svg',
	},
	// {
	// 	code: 'IT',
	// 	name: 'Italia',
	// 	dial: '+39',
	// 	flag: '/flags/img_flag_italia_32.svg',
	// },
	{
		code: 'AE',
		name: 'United Arab Emirates',
		dial: '+971',
		flag: '/flags/img_flag_United Arab Emirates_32.svg',
	},
	{
		code: 'SA',
		name: 'Saudi Arabia',
		dial: '+966',
		flag: '/flags/img_flag_Saudi Arabia_32.svg',
	},
	// {
	// 	code: 'QA',
	// 	name: 'Qatar',
	// 	dial: '+974',
	// 	flag: '/flags/img_flag_qatar_32.svg',
	// },
	// {
	// 	code: 'OM',
	// 	name: 'Oman',
	// 	dial: '+968',
	// 	flag: '/flags/img_flag_oman_32.svg',
	// },
	// {
	// 	code: 'KW',
	// 	name: 'Kuwait',
	// 	dial: '+965',
	// 	flag: '/flags/img_flag_kuwait_32.svg',
	// },
	// {
	// 	code: 'BH',
	// 	name: 'Bahrain',
	// 	dial: '+973',
	// 	flag: '/flags/img_flag_bahrain_32.svg',
	// },
	// {
	// 	code: 'MM',
	// 	name: 'Myanmar',
	// 	dial: '+95',
	// 	flag: '/flags/img_flag_myanmar_32.svg',
	// },
	// {
	// 	code: 'PK',
	// 	name: 'Pakistan',
	// 	dial: '+92',
	// 	flag: '/flags/img_flag_pakistan_32.svg',
	// },
	// {
	// 	code: 'BD',
	// 	name: 'Bangladesh',
	// 	dial: '+880',
	// 	flag: '/flags/img_flag_bangladesh_32.svg',
	// },
	// {
	// 	code: 'LK',
	// 	name: 'Sri Lanka',
	// 	dial: '+94',
	// 	flag: '/flags/img_flag_Sri Lanka_32.svg',
	// },
	// {
	// 	code: 'NP',
	// 	name: 'Nepal',
	// 	dial: '+977',
	// 	flag: '/flags/img_flag_nepal_32.svg',
	// },
	// {
	// 	code: 'MN',
	// 	name: 'Mongolia',
	// 	dial: '+976',
	// 	flag: '/flags/img_flag_mongolia_32.svg',
	// },
	// {
	// 	code: 'UZ',
	// 	name: 'Uzbekistan',
	// 	dial: '+998',
	// 	flag: '/flags/img_flag_uzbekistan_32.svg',
	// },
	// {
	// 	code: 'KG',
	// 	name: 'Kyrgyzstan',
	// 	dial: '+996',
	// 	flag: '/flags/img_flag_kyrgyzstan_32.svg',
	// },
	// {
	// 	code: 'KZ',
	// 	name: 'Kazakhstan',
	// 	dial: '+7',
	// 	flag: '/flags/img_flag_Kazakhstan_32.svg',
	// },
] as const;
